import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function LHWhatIs() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1632">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1633">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-1634">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1635">
            WHAT IS LASER HAIR REMOVAL?
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-1636"></div>

          <p className="text-black text-lg leading-[1.8] font-body mb-12" data-id="element-1637">
            Laser hair removal treatment offers an effective solution for
            eliminating unwanted hair. This procedure involves exposing the hair
            to pulses of laser light that is absorbed by the melanin in the hair
            shaft and hair follicles. Melanin is responsible for the color of
            the hair.
          </p>

          <div className="relative max-w-[700px] mx-auto mb-12" data-id="element-1638">
            <div className="text-[#FF1493] text-[60px] font-serif leading-none select-none opacity-60 mb-2" data-id="element-1639">
              &ldquo;
            </div>
            <p className="font-serif italic text-black text-lg lg:text-[22px] leading-[1.6]" data-id="element-1640">
              Laser hair removal is a game-changer for achieving smooth,
              hair-free skin. It's precise, fast, and delivers long-lasting
              results, giving you the confidence to embrace every day with ease.
            </p>
          </div>

          <div className="space-y-6 text-[#333333] text-[17px] leading-[1.8] font-body" data-id="element-1641">
            <p data-id="element-1642">
              Once absorbed, the light energy is converted into heat. This heat
              damages the hair follicle, particularly the bulb and bulge, which
              are responsible for hair growth. The heat generated by the laser
              damages or destroys the hair follicle, preventing or delaying
              future hair growth.
            </p>
            <p data-id="element-1643">
              The goal is to target the follicles during the active growth phase
              (anagen phase) for optimal results. In order to target the melanin
              in the hair follicles while minimizing damage to the surrounding
              skin, we carefully select the laser parameters, including
              wavelength and pulse duration.
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}